import { render, staticRenderFns } from "./DeanWords.vue?vue&type=template&id=849629a2&scoped=true&"
import script from "./DeanWords.vue?vue&type=script&lang=js&"
export * from "./DeanWords.vue?vue&type=script&lang=js&"
import style0 from "./DeanWords.vue?vue&type=style&index=0&id=849629a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849629a2",
  null
  
)

export default component.exports